import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 9a5 5 0 0 0 -5 -5h-2a5 5 0 0 0 -5 5v6a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5v-6","key":"svg-0"}],["path",{"d":"M13 15l5 5","key":"svg-1"}]]

/**
 * IconLetterQ
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbGV0dGVyLXEiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTE4IDlhNSA1IDAgMCAwIC01IC01aC0yYTUgNSAwIDAgMCAtNSA1djZhNSA1IDAgMCAwIDUgNWgyYTUgNSAwIDAgMCA1IC01di02IiAvPgogIDxwYXRoIGQ9Ik0xMyAxNWw1IDUiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/letter-q
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconLetterQ = createReactComponent('outline', 'letter-q', 'LetterQ', __iconNode);

export default IconLetterQ;